import axios from 'axios'

const getQEMISsec = ({ commit, state }, payload) => {
  const config = {
    params: {
      acc_code: payload.acc_code,
      sch_code: payload.sch_code
    }
  }
  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងផ្ទុកទិនន្ន័យពីម៉ាសុីនមេ...' }, { root: true })
  axios.get('/qemis/sec', config)
    .then((response) => {
      commit('LOAD_DATA_QEMIS_SEC', response.data)
      commit('uiControl/RSTATE_SUCCESS', null, { root: true })
      //add below code for disable/enable save button      
      commit('uiControl/SET_SCHOOL_STATE', response.data.state_code.sta_code, { root: true })
      if (state.school_dt.res === '0') { // check if school not found on the database
        commit('uiControl/RSTATE_ERRORS', { errMessage: 'ពុំមានសាលានេះទេ!' }, { root: true })
      }
      // state.school_dt = response.data.value
      // console.log(state.school_dt)
    }, (error) => {
      //console.log(error)
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
    })
}

const loadDefaultQEMISsec = ({ commit, state }) => {
  commit('LOAD_DEFAULT_QEMIS_SEC')
}

const searchQEMISsec = ({ commit, state }, payload) => {

}

const saveQEMISsec = ({ commit, state }, payload) => {
  // var d = JSON.parse(JSON.stringify(state.school_dt))
  var d = state.school_dt
  let t = d.type_code
  let sId = d.state_code.sta_id
  let secDt = ''
  let sCode = 33 // 32 entry & Invalid, 33 entry & valided, 35 entry and closed ====> UPGRADE IN FUTURE
  if (t === 3) { // type_code = 3 ---> G7-G9
    // qemis G7
    secDt = '('
    for (let i = 0; i < d.sco_g7.length; i++) {
      secDt += d.sco_g7[i].id + ',' + d.sco_g7[i].dt_g + ',' + d.sco_g7[i].dt_b + '),('
    }
    // qemis G8
    for (let i = 0; i < d.sco_g8.length; i++) {
      secDt += d.sco_g8[i].id + ',' + d.sco_g8[i].dt_g + ',' + d.sco_g8[i].dt_b + '),('
    }
    // qemis G9
    for (let i = 0; i < d.sco_g9.length; i++) {
      secDt += d.sco_g9[i].id + ',' + d.sco_g9[i].dt_g + ',' + d.sco_g9[i].dt_b + '),('
    }
    secDt = secDt.slice(0, -2)
  } else if (t === 5) { // type_code = 5 ---> G7-G12
    // qemis G7
    secDt = '('
    for (let i = 0; i < d.sco_g7.length; i++) {
      secDt += d.sco_g7[i].id + ',' + d.sco_g7[i].dt_g + ',' + d.sco_g7[i].dt_b + '),('
    }
    // qemis G8
    for (let i = 0; i < d.sco_g8.length; i++) {
      secDt += d.sco_g8[i].id + ',' + d.sco_g8[i].dt_g + ',' + d.sco_g8[i].dt_b + '),('
    }
    // qemis G9
    for (let i = 0; i < d.sco_g9.length; i++) {
      secDt += d.sco_g9[i].id + ',' + d.sco_g9[i].dt_g + ',' + d.sco_g9[i].dt_b + '),('
    }
    // qemis G10
    for (let i = 0; i < d.sco_g10.length; i++) {
      secDt += d.sco_g10[i].id + ',' + d.sco_g10[i].dt_g + ',' + d.sco_g10[i].dt_b + '),('
    }
    // qemis G11
    for (let i = 0; i < d.sco_g11.length; i++) {
      secDt += d.sco_g11[i].id + ',' + d.sco_g11[i].dt_g + ',' + d.sco_g11[i].dt_b + '),('
    }
    // qemis G18
    for (let i = 0; i < d.sco_g18.length; i++) {
      secDt += d.sco_g18[i].id + ',' + d.sco_g18[i].dt_g + ',' + d.sco_g18[i].dt_b + '),('
    }
    // Implement latter
    // qemis G12
    for (let i = 0; i < d.sco_g12.length; i++) {
      secDt += d.sco_g12[i].id + ',' + d.sco_g12[i].dt_g + ',' + d.sco_g12[i].dt_b + '),('
    }
    // qemis G19
    // Implement latter
    for (let i = 0; i < d.sco_g19.length; i++) {
      secDt += d.sco_g19[i].id + ',' + d.sco_g19[i].dt_g + ',' + d.sco_g19[i].dt_b + '),('
    }
    secDt = secDt.slice(0, -2)
    // console.log(secDt)
  } else if (t === 4) { // type_code = 4 ----> G10-G12
    secDt = '('
    // qemis G10
    for (let i = 0; i < d.sco_g10.length; i++) {
      secDt += d.sco_g10[i].id + ',' + d.sco_g10[i].dt_g + ',' + d.sco_g10[i].dt_b + '),('
    }
    // qemis G11
    for (let i = 0; i < d.sco_g11.length; i++) {
      secDt += d.sco_g11[i].id + ',' + d.sco_g11[i].dt_g + ',' + d.sco_g11[i].dt_b + '),('
    }
    // qemis G18
    for (let i = 0; i < d.sco_g18.length; i++) {
      secDt += d.sco_g18[i].id + ',' + d.sco_g18[i].dt_g + ',' + d.sco_g18[i].dt_b + '),('
    }
    // Implement latter
    // qemis G12
    for (let i = 0; i < d.sco_g12.length; i++) {
      secDt += d.sco_g12[i].id + ',' + d.sco_g12[i].dt_g + ',' + d.sco_g12[i].dt_b + '),('
    }
    // qemis G19
    // Implement latter
    for (let i = 0; i < d.sco_g19.length; i++) {
      secDt += d.sco_g19[i].id + ',' + d.sco_g19[i].dt_g + ',' + d.sco_g19[i].dt_b + '),('
    }
    secDt = secDt.slice(0, -2)
  }
  // posting to server
  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងរក្សាទិនន្ន័យទៅម៉ាសុីនមេ...' }, { root: true })
  axios.post('/qemis/sec', { sta_id: sId, secDt: secDt, state_code: sCode })
    .then((response) => {
      // console.log(response.data + 'Done')
      if (response.data === 0) {
        commit('uiControl/RSTATE_SAVE_SUCCESS', { message: 'ទិនន្ន័យរក្សាទុកត្រឹមត្រូវក្នុងម៉ាសុីនមេ' }, { root: true })
      } else {
        commit('uiControl/RSTATE_ERRORS', { errMessage: 'ការរក្សាទុកទិន្នន័យមានបញ្ហា! មូលហេតុ៖ ' + response.data }, { root: true })
      }
    }, (error) => {
      // console.log(error)
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
    })
}

const logQEMISsec = ({ commit, state }) => {
  //console.log(state.school_dt.sco_g7[0].dt)
}
// Secondary school data sessions
const getQEMISSec = ({ commit, state }, payload) => {
}

const saveQEMISSec = ({ commit, state }, payload) => {
}

export {
  loadDefaultQEMISsec,
  searchQEMISsec,
  getQEMISsec,
  saveQEMISsec,
  logQEMISsec,
  getQEMISSec,
  saveQEMISSec
}
